'use strict';

DoohApps
.directive('autoSelect', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            $timeout(function () {
                element[0].setSelectionRange(0, element[0].value.length)
            });
        }
    };
}]);